export default "__VITE_ASSET__711c75e8__"